import { Fragment } from "react";
import { useEffectOnce } from "../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import { setUnAuthorizedPageOff } from "../redux/slices/unauthorizedpageslice";
import { Navigate } from "react-router-dom";
import { ROUTING_PATHS } from "../settings";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const UnAuthorizedPage = props => {
    const dispatch = useDispatch();
    const isLegal = useSelector(state => state.unAuthorizedPage);
    const { t } = useTranslation();
   
    useEffectOnce(()=>{
        return () =>{
            dispatch(setUnAuthorizedPageOff());
        }
    }, []);

    if (!isLegal)
           return <Navigate to={ROUTING_PATHS.home} replace={true} />
    else
        return (
            <Fragment>
                <div className="unauthorized-page">
                    <div style={{display: "flex", height: "100%", justifyContent: "center", alignItems: "center"}}>
                        <h1>{t("unauthorized.unauthorized")}</h1>
                    </div>
                </div>
                <style>
                {
                    `
                        .unauthorized-page
                        {
                            display: flex;
                            height: 100%;
                            align-items: center;
                            flex: 1;
                            justify-content: center;
                            position: relative;
                            background-color: transparent;
                        }
                    `
                }
            </style>
            </Fragment>
        )
};

//export const UnAuthorizedPage = {Component: UnAuthorized};